import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const OurSolutionConnected = () =>
    <div>
        <Heading size={6} textColor="secondary" caps>
            Our Solution - AI POWERED SLIDES
        </Heading>
        <Text textSize={30} textColor="primary">
            Intelligent and Connected
        </Text>
        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>Understand how prospects are engaging with your presentations, interests and level of engagement</ListItem>
            <ListItem textSize={25}>Integrate with existing CRM, CDP, and other platforms so it’s part of current sales workflow</ListItem>
        </List>
    </div>

export default OurSolutionConnected;






// WEBPACK FOOTER //
// ./src/slides/OurSolutionConnected.js